export default __webpack_public_path__ + "static/media/english-to-tagalog-mobile-2.519ae61d.png";